/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */
var MATERIAL_LINK_SELECTOR = '[data-link-role="trigger"]';
var SUPPLY_FORM_LINK_SELECTOR = '[data-form-link-role="trigger"]';
var EMAIL_LINK_SELECTOR = '[data-contacts-role="email"]';
var FORM_LINK_SELECTOR = '[data-contacts-role="form"]';
var REQUEST_END = ' - Anfrage via Website';
var URL_TAB_SELECTOR = '[data-tab-behavior="change-url"]';
var URL_ACC_SELECTOR = 'collapse';
var CURRENT_URL = document.location.href;
var MAIN_NAV_DROPDOWN = '[data-nav-role="main-nav-dropdown"]';
var MAGN_ALLOYS_FORM_OF_SUPPLY_EN = "Contact form message - magnetic alloys";
var MAGN_ALLOYS_FORM_OF_SUPPLY_DE = "Nachricht von Website-Formular - magnetische Legierungen";

var UMLAUT_MAP = {
  '\u00fc': 'ue',
  '\u00e4': 'ae',
  '\u00f6': 'oe',
  '\u00df': 'ss'
};

var UMLAUT_MAP_IVERTED = {
  'ue' : 'ü',
  'ae' : 'ä',
  'oe' : 'ö',
  'ss' : 'ß'
};
/**
 * ------------------------------------------------------------------------
 * Helpers
 * ------------------------------------------------------------------------
 */
var prevScrollpos = window.scrollY;
// function replaceUmlaute(str) {
//   function getChar(char) {
//     return UMLAUT_MAP[char];
//   }
//   return str
//     .replace(new RegExp('[' + Object.keys(UMLAUT_MAP).join('|') + ']',"g"), getChar);
// }
//
// function recoverUmlaute(str) {
//   function getChar(substr) {
//     return UMLAUT_MAP_IVERTED[substr];
//   }
//   return str
//     .replace(new RegExp(Object.keys(UMLAUT_MAP_IVERTED).join('|'),"g"), getChar);
// }

function replaceAll(str,mapObj){
    var re = new RegExp(Object.keys(mapObj).join("|"),"gi");

    return str.replace(re, function(matched){
        return mapObj[matched.toLowerCase()];
    });
}

/**
 * ------------------------------------------------------------------------
 * Layout
 * ------------------------------------------------------------------------
 */
function generateLangMenuLabel() {
  if (document.getElementById('langSelectorButton') !== 'undefined') {
    if (Array.from(document.getElementsByClassName('langSelectorItemActive'))[0] !== 'undefined') {
      document.getElementById('langSelectorButton').innerHTML = Array.from(document.getElementsByClassName('langSelectorItemActive'))[0].innerHTML;
    }
  }
}

/**
 * ------------------------------------------------------------------------
 * Magnetic Materials Functionality
 * ------------------------------------------------------------------------
 */
function getSubjectTable(parent) {
  var productCode;
  var form;
  var material;
  var subject;
  productCode = parent.querySelector('.product-code').innerHTML;
  form = parent.querySelector('.product-code').getAttribute('data-subject-name');
  material = parent.querySelector('.material-name').innerHTML;
  subject = form + ' ' + material + ' (' + productCode + ')';
  subject = subject.replace(/\s+/g, ' '); // delete redundant whitespaces
  return subject;
}

function showForm(formLink, product) {
  var form = document.getElementById('requestForm');
  //var productHeading = document.getElementById('subtitle-product');
  //var subjectField = document.getElementById('subject');
  var subjectField = document.getElementsByClassName('magnetic-alloys-form-subject')[0];
  form.classList.add('show');
  //productHeading.innerHTML = 'Produkt: ' + product;
  //subjectField.value = product;
  scrollToForm(form);
}

function addHideLinksClickHandler(hideAlertLink) {
  var linkType = hideAlertLink.dataset.alertType;
  hideAlertLink.addEventListener('click', function(event) {
    event.preventDefault();
    var links = getHideLinksArray();
    links.forEach(function(link){
      if (link.dataset.alertType == linkType) {
        link.parentElement.parentElement.classList.add('fadeAlert');
        setTimeout(function() {
          link.parentElement.parentElement.style.display = "none";
        }, 300);
      }
    });
  });
}

function getButtonContents(button) {
  var contents = button.innerHTML;
  var contentsArray = contents.split(' ');
  var formString = contentsArray[contentsArray.length-1];
  var formSimplified = formString.substring(0, (formString.length-1));
  // console.log(formSimplified);
  return formSimplified;
}

function openTabFS() {
  var tabForm = document.getElementById("lieferformen-tab");
  var tab = new bootstrap.Tab(tabForm);
  tab.show();
}

function addMatFormLinksClickHandler(matFormLink) {
  'use strict';
  var linkName;
  matFormLink.addEventListener('click', function(event) {
    event.preventDefault();
    linkName = getButtonContents(this);
    openTabFS();
    closeAllCollapsilbe(getCollapsible()); // closes all accorion items
    openAccordionItemFS(linkName, this); // opens target accorion item
  });
}

function setCurrentAIFS(collapseEl) {
  return collapseEl;
}

function getCollapsible(){
  var collapseElementList = getAccodrionTriggers();
  var collapseList = collapseElementList.map(function (collapseEl) {
    return new bootstrap.Collapse(collapseEl, { toggle: false });
  });
  return collapseList;
}

function closeAllCollapsilbe(collapseList) {
  collapseList.forEach(function(item) {
    item.hide();
    // item.dispose();
  });
}

function openAccordionItemFS(linkName, sourceButton) {
  var targetItemNodes = document.getElementsByClassName("materials-accordion_heading");
  var targetItemArray = [].slice.call(targetItemNodes);
  var targetItemStringArray = [];
  var bsCollapse;
  var i = 0;
  for(i = 0; i < targetItemArray.length; i++) {
    targetItemStringArray[i] = targetItemArray[i].innerHTML.toLowerCase();
    if (targetItemStringArray[i].includes(linkName.toLowerCase())) {
      bsCollapse = new bootstrap.Collapse(targetItemArray[i].parentElement.parentElement.nextSibling);
      bsCollapse.toggle();
      //sortProductTable(sourceButton, bsCollapse);
    }
  }
}

function addMatLinksClickHandler(materialLink) {
  'use strict';
  var subject;
  var linkType;
  var cardForm;
  var cardAlloy;

  materialLink.addEventListener('show.bs.dropdown', function(event) {
    //console.log("addEventListener");
    linkType = this.parentElement.parentElement.getAttribute('data-link-type');
    var formLink = this.nextSibling.querySelector(FORM_LINK_SELECTOR);
    if (linkType == "table") {
      subject = getSubjectTable(this.parentElement.parentElement.parentElement.parentElement); // <tr>
      //setSubject(this.parentElement, subject);
      formLink.addEventListener('click', function(event) {
        event.preventDefault();
        showForm(formLink, subject);
      });
    }
    if (linkType == "card") {
      cardForm = this.parentElement.parentElement.parentElement.parentElement.getElementsByTagName('h5')[0].innerHTML; // get card title
      cardAlloy = this.parentElement.parentElement.parentElement.getAttribute('data-alloy');
      subject = cardForm + ' ' + cardAlloy.toUpperCase();
      //setSubject(this.parentElement, subject);
      formLink.addEventListener('click', function(event) {
        event.preventDefault();
        showForm(formLink, subject);
      });
    }
  });
}

function setSubject(parent, subject) {
  'use strict';
  var mailLink = parent.querySelector(EMAIL_LINK_SELECTOR);
  //var formLink = parent.querySelector(FORM_LINK_SELECTOR);
  mailLink.setAttribute('href', 'mailto:nm@3wfabrik.de?Subject=' + subject + REQUEST_END);
  //formLink.setAttribute('href', 'magnetische-legierungen-contact.html?product=' + subject);
}

function getMatLinksArray() {
  'use strict';
  var materialLinks = document.querySelectorAll(MATERIAL_LINK_SELECTOR);
	var materialLinksArray = [].slice.call(materialLinks);
	return materialLinksArray;
}

function getMatFormLinksArray() {
  'use strict';
  var matFormLinks = document.querySelectorAll(SUPPLY_FORM_LINK_SELECTOR);
	var matFormLinksArray = [].slice.call(matFormLinks);
	return matFormLinksArray;
}

function getHideLinksArray() {
  'use strict';
  var hideLinks = document.getElementsByClassName('hide-alert');
	var hideLinksArray = [].slice.call(hideLinks);
	return hideLinksArray;
}

function scrollToForm(form) {
    var domRect = form.getBoundingClientRect();
   // console.log(form);
    window.scrollTo({
      top: document.body.scrollHeight,
      left: domRect.x,
      behavior: 'smooth'
  });
}

function checkFormStatus() {
  var warnings = document.getElementsByClassName("form_warning");
  if (warnings.length !== 0) {
    var form = document.getElementById("requestForm");
    form.classList.add("show");
    scrollToForm(form);
  }
}

function setFormSubject() {
  var currentUrl = document.location.href;
  var subjectField = [].slice.call(document.getElementsByClassName("magnetic-alloys-form-subject"))[0];
  if (currentUrl.includes("/en/")) {
    subjectField.value = MAGN_ALLOYS_FORM_OF_SUPPLY_EN;
  } else {
    subjectField.value = MAGN_ALLOYS_FORM_OF_SUPPLY_DE;
  }
}
/**
 * ------------------------------------------------------------------------
 * Deep links implementation
 * ------------------------------------------------------------------------
 */
function getAccodrionTriggers(collapseList) {
  'use strict';
  var urlAcc = document.getElementsByClassName(URL_ACC_SELECTOR);
  var urlAccArray = [].slice.call(urlAcc);
  var i = 0;
  urlAccArray.forEach(function(item) {
    if (item.getAttribute('id') == 'requestForm') {
      urlAccArray.splice(i, 1);
    }
    i++;
  });
  return urlAccArray;
}

function getUrlTabsArray() {
  'use strict';
  var urlTabs = document.querySelectorAll(URL_TAB_SELECTOR);
  var urlTabsArray = [].slice.call(urlTabs);
  return urlTabsArray;
}

function addUrlAccordionEventHandler(accItem, itemIndex) {
  'use strict';
  var getParamKey = '&item' + itemIndex;
  var i = 0;
  // &item=
  accItem.addEventListener('shown.bs.collapse', function() {
    var currentUrl = document.location.href;
    var getParamValue = replaceAll(accItem.getAttribute('id'), UMLAUT_MAP);
    var bugString =  '=' + getParamValue + '=' + getParamValue;
    if (!(currentUrl.includes(getParamKey))) { // if no item shown,
      window.history.replaceState(null, '', currentUrl + getParamKey + '=' + getParamValue);
      var modifiedUrl = document.location.href;
      if(modifiedUrl.includes(bugString)) {
        var index = modifiedUrl.length - getParamValue.length - 1;
        var modUrl = modifiedUrl.substring(0, index);
        window.history.replaceState(null, '', modUrl);
      }
    }
  });
  accItem.addEventListener('hidden.bs.collapse', function() {
    i++;
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var itemName = urlParams.get(getParamKey.substring(1));
    if (itemName) {
      var currentUrl = document.location.href;
      var cutIndex1 = currentUrl.indexOf(getParamKey); // &item
      var subUrl1 = currentUrl.substring(0, cutIndex1); // string vor &item
      var getParam = getParamKey + '=' + itemName;
      var subUrl2 = currentUrl.substring(cutIndex1 + getParam.length, currentUrl.length);
      var modifiedUrl = subUrl1.concat(subUrl2);
      window.history.replaceState(null, '', modifiedUrl);
    }
  });
}

function addUrlTabClickHandler(urlTab) {
  var tabName = urlTab.getAttribute('aria-controls');
  var currentUrl = document.location.href;
  var urlArray = currentUrl.split('?');
  var mainUrl = urlArray[0];
  urlTab.addEventListener('shown.bs.tab', function(event) {
    window.history.replaceState(null, 'Title', mainUrl + '?tab=' + tabName);
  });
  urlTab.addEventListener('hidden.bs.tab', function(event) {
    closeAllCollapsilbe(getCollapsible()); // closes all accorion items
    var cutString = '?tab=';
    var currentUrl = document.location.href;
    var modifiedUrl;
    var cutIndex = currentUrl.indexOf(cutString);
    modifiedUrl = currentUrl.substring(0, cutIndex);
    window.history.replaceState(null, 'Title', modifiedUrl);
  });

}

// URL abfragen beim ersten Laden der Seite
function recoverAppState(tabs, accItemIndex) {
  var i = 0;
  var currentURL = document.location.href;
  var queryString = window.location.search;
  if(queryString !== '') { // if app state should be recovered
    //console.log(queryString);
    var accItems = []; // Generieren von GET-Parametern "item1 ... item19"
    for (i = 0; i < (accItemIndex-1); i++){
      accItems[i] = 'item' + (i+1);
    }
    var urlParams = new URLSearchParams(queryString);
    var tabName = urlParams.get('tab');
    var tabEl = document.getElementById(tabName + '-tab');
    var tab = new bootstrap.Tab(tabEl);
    //console.log(tab);
    tab.show();

    accItems.forEach(function(accItem) { // lists all items in URL
      if(urlParams.has(accItem)) {
        var itemName = replaceAll(urlParams.get(accItem), UMLAUT_MAP_IVERTED);
        var item = new bootstrap.Collapse(document.getElementById(itemName));
        item.show();
      }
    });
  } else {
    window.history.replaceState(null, 'Title', currentURL + '?tab=legiereungen'); // Default URL
  }
}

function initializeMaterialsPage() {
	'use strict';
	var materialLinks = getMatLinksArray();
  var hideAlertLinks = getHideLinksArray();
  var matFormLinks = getMatFormLinksArray();
  var urlTabs = getUrlTabsArray();
  var urlAccordionTriggers = getAccodrionTriggers();
  var accTriggersBS = getCollapsible(); // Enables multiple accordion items to be shown
  var accItemIndex = 1;
  requestFormClickHandler(document.getElementById('requestForm'));
  //addReqFormSubmitHandler(document.getElementById('mag-materials-contact-form'));
  materialLinks.forEach(addMatLinksClickHandler); // Contact functionality, with material name as e-mail subject
  hideAlertLinks.forEach(addHideLinksClickHandler); // Hides message "thermal treatment" and "futher treatment"
  matFormLinks.forEach(addMatFormLinksClickHandler); // Go to "Form of Supply" tab, hide current tab, resort table
  urlTabs.forEach(addUrlTabClickHandler); // Change URL when showing a tab
  urlAccordionTriggers.forEach(function(item) {
    addUrlAccordionEventHandler(item, accItemIndex);
    accItemIndex++;
  }); // Change URL when showing an accordion item

  recoverAppState(urlTabs, accItemIndex);
  checkFormStatus();
  //setFormSubject();
//  window.history.replaceState(null, 'Title', CURRENT_URL + '?' + urlTabs[0].getAttribute('aria-controls')); // initial loading URL
}

function initializeGeneralEvents() {
  generateLangMenuLabel();
  if(document.getElementById('alloysTabs')) {
    initializeMaterialsPage();
  }
}

function setSubtitle(product) {
  document.getElementById('subtitle-product').innerHTML = product;
}
// -- END: Magnetic materials - contact links functionality -- //

// Smooth scrolling to request form when open
function requestFormClickHandler(requestForm){
  requestForm.addEventListener('shown.bs.collapse', function () {
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: 'smooth'
    });
  });
}

function sortProductTable(link, targetAccordionItem){
  var alloy = link.parentElement.dataset.alloy;
  var idSelector = "sample-products-" + alloy;
  var table = document.getElementById(idSelector);
  var tbody = table.getElementsByTagName("tbody");
  var tds = table.getElementsByClassName("material-name");
  var rowsAlloy = []; // Array mit Legierungszeilen
  var row;
  var j = 0;
  for (i = 0; i < (tds.length); i++) {
    row = tds[i].parentElement;
    var tableContent = tds[i].innerHTML.toLowerCase();
    if (tableContent.includes(alloy)) {
      rowsAlloy.push(row); // Hinzufügen der Zeilen mit Legierungen zum Legierungs-Array
      row.remove();
      tbody[0].prepend(rowsAlloy[j]);
      j++;
    }
  }
}

/**
 * ------------------------------------------------------------------------
 * Main Nav Offcanvas
 * ------------------------------------------------------------------------
 */
function darkenScreen(){
  document.querySelector('.screen-darken').classList.add('active');
}
function removeDarkScreen(){
  document.querySelector('.screen-darken').classList.remove('active');
}
function closeOffcanvas(){
  document.querySelector('.offcanvas-collapse').classList.remove('open');
  removeDarkScreen();
}
/**
 * ------------------------------------------------------------------------
 * Main Nav Dropdown
 * ------------------------------------------------------------------------
 */
function getMainNavDropdowns() {
  'use strict';
  var dropdowns = document.querySelectorAll(MAIN_NAV_DROPDOWN);
  var dropdownsArray = [].slice.call(dropdowns);
  	return dropdownsArray;
}

function addNavDropdownsClickHandler(dropdown) {
  'use strict';
  var linkName;
  dropdown.addEventListener('show.bs.dropdown', function () {
    dropdown.classList.remove('closed');
    dropdown.classList.add('opened');
  });
  dropdown.addEventListener('hide.bs.dropdown', function () {
    dropdown.classList.remove('opened');
    dropdown.classList.add('closed');
  });
}

window.onscroll = function() {
  var currentScrollPos = window.scrollY;
  if (prevScrollpos > currentScrollPos) {
    document.getElementById('headerNav').style.top = "0";
    if (document.getElementById('subNav')) document.getElementById('subNav').style.top = "50px";
    if (document.getElementById('section-menu-scroll-spy')) document.getElementById('section-menu-scroll-spy').style.top = "60px";
  } else {
    document.getElementById('headerNav').style.top = "-50px";
    if (document.getElementById('subNav')) document.getElementById('subNav').style.top = "0";
    if (document.getElementById('section-menu-scroll-spy')) document.getElementById('section-menu-scroll-spy').style.top = "0";
  }
  prevScrollpos = currentScrollPos;
};

function initializeMainNav() {
  'use strict';
  var openSearchButton = document.getElementById('searchboxOpen');
  var closeSearchButton = document.getElementById('searchboxClose');
  var searchForm = document.getElementById('searchboxFieldset');
  var searchBox = document.getElementById('tx-indexedsearch-searchbox-sword');
  var mainNavContainer = document.getElementById('mainNavContainer');
  var navDropdowns = getMainNavDropdowns();
  navDropdowns.forEach(addNavDropdownsClickHandler);

  openSearchButton.addEventListener('click', function(event) {
    this.classList.remove('active');
    searchForm.classList.add('active');
    closeSearchButton.classList.add('active');
    searchBox.focus();
    mainNavContainer.classList.add('search-active');
  });
  closeSearchButton.addEventListener('click', function(event) {
    openSearchButton.classList.add('active');
    searchForm.classList.remove('active');
    closeSearchButton.classList.remove('active');
    mainNavContainer.classList.remove('search-active');
  });
  document.querySelector('#navbarSideCollapse').addEventListener('click', function () {
    document.querySelector('.offcanvas-collapse').classList.add('open');
    darkenScreen();
  });
  document.querySelector('#navbarCloseOffcanvas').addEventListener('click', function () {
    closeOffcanvas();
  });
  document.querySelector('.screen-darken').addEventListener('click', function(event){
    closeOffcanvas();
  });
}
